import { Modal, Button } from "react-bootstrap";

type AdequacaoModalConfirmacaoProps = {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  
  isLoading?: boolean;
};

const AdequacaoModalConfirmacao = ({
  show,
  onClose,
  onConfirm,
  isLoading = false,
}: AdequacaoModalConfirmacaoProps) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        if (isLoading) return;
        onClose();
      }}
      centered
      backdrop={isLoading ? "static" : true}
      keyboard={!isLoading}
    >
      <Modal.Header closeButton={!isLoading}>
        <Modal.Title>Confirmação</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        Deseja realmente enviar a adequação dessa(s) documentação(ões)?
      </Modal.Body>

      <Modal.Footer className="border-0 merit-confirm-footer">
        <Button
          type="button"
          variant="outline-secondary"
          className="merit-confirm-btn-nao"
          onClick={onClose}
          disabled={isLoading}
        >
          Não
        </Button>
        <Button
          type="button"
          variant="primary"
          className="merit-confirm-btn-sim"
          onClick={onConfirm}
          disabled={isLoading}
        >
          Sim
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdequacaoModalConfirmacao;
